module.exports = __webpack_public_path__ + "img/wizard_video2.b45fbc4f.png";